import React from "react";
import { Link } from "react-router-dom";

const Background = ({ image, name }) => {
  return (
    <div
      style={{
        backgroundImage: `url(${image})`,
      }}
      className="backgroundImg"
    >
      <div className="layerbg">
        <div className="mx-3">
          <h1 className="primaryColor background-heading">{name}</h1>
          <div className="text-center">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/" className="accentColor">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item primaryColor" aria-current="page">
                {name}
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Background;
